import { useState, useMemo } from 'react';
import type { Job, Category } from '../data/jobs';

export const useJobFilter = (jobs: Job[]) => {
  const [selectedCategory, setSelectedCategory] = useState<Category>('All');

  const filteredJobs = useMemo(() => {
    if (selectedCategory === 'All') {
      return jobs;
    }
    return jobs.filter(job => job.category === selectedCategory);
  }, [jobs, selectedCategory]);

  return {
    selectedCategory,
    setSelectedCategory,
    filteredJobs
  };
}; 